import { useEffect } from "react";
import { useCart } from "../../../../hooks/useCart";
import { useParams } from "react-router-dom";
import { useGetInfo } from "../../../../hooks/useGetInfo";
import { calculateCartItem } from "../../../../helpers";
import usePendingCheckoutSession from "../../../../hooks/usePendingCheckoutSession";

export const useSellModeCart = () => {
  const { store_id } = useParams();
  const { getStoreInfo } = useGetInfo();
  const storeDetails = getStoreInfo(store_id);
  const { cartItems, clearCartItem, addCartItemToLocalStorage, ...otherItems } =
    useCart({});
  const { isPendingCheckout, handlePendCheckout } = usePendingCheckoutSession({
    isEnabled: false,
  });

  useEffect(() => {
    if (storeDetails) {
      let newData = [];
      if (localStorage.getItem(`cartItems${store_id}`))
        newData = JSON.parse(localStorage.getItem(`cartItems${store_id}`));

      const data = calculateCartItem({
        cart_items: newData,
        vat: storeDetails?.vat,
        service_charge: storeDetails?.service_charge || 0,
      });
      addCartItemToLocalStorage({
        ...data,
      });
    }
  }, [storeDetails]);

  return {
    store_id,
    cartItems,
    clearCartItem,
    storeDetails,
    addCartItemToLocalStorage,
    isPendingCheckout,
    handlePendCheckout,
    ...otherItems,
  };
};
